import axios, { AxiosInstance } from "axios";

export interface FormDataProps {
  email: string;
  firstname: string | null;
  lastname: string | null;
  type: string;
  operation?: string;
}

export const client: AxiosInstance = axios.create({
  baseURL: process.env.GATSBY_API_URL,
});

export const sendDataToApi = (val: FormDataProps) => {
  return client.post("/marketing_leads", val);
};
